import { combineReducers } from 'redux';
import oauthReducer from './oauth/oauthSlice';
import filterMenu from './menu/filterMenu';
import examReducer from './perFormExam/perFormExam';
import navlayoutSlice from './navlayout/navlayoutSlice';
const reducers = combineReducers({
  oauth: oauthReducer,
  exam: examReducer,
  filterMenu: filterMenu,
  navlayout: navlayoutSlice,
});
export default reducers;